import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { switchMap } from 'rxjs/operators';

import { AppComponent } from '../app.component';
import { HubService } from '../services/hub.service';
import { Hub } from '../types/hub';
import { HubIssue } from '../types/hubissue';
import { IssueAction } from '../types/issue-action';
import { IssueActionType } from '../types/issue-action-type';
import { IssuePriority } from '../types/issue-priority';
import { IssueSource } from '../types/issue-source';
import { IssueStatus } from '../types/issue-status';
import { IssueTagAction } from '../types/issue-tag-action';
import { IssueTag } from '../types/issue-tag';

@Component({
  selector: 'expanded-issue',
  templateUrl: './expanded-issue.component.html',
  styleUrls: ['./expanded-issue.component.css'],
  providers: [ HubService ],
})

export class ExpandedIssueComponent implements OnInit {
  @Input() inHub: Hub;
  @Input() issue: HubIssue;
  @Input() issue_sources = <IssueSource[]>[];
  @Input() issue_statuses = <IssueStatus[]>[];
  @Input() issue_priorities = <IssuePriority[]>[];
  @Input() action_types = <IssueActionType[]>[];

  @Input() issue_tags = <IssueTag[]>[];
  @Input() issue_tag_actions = <IssueTagAction[]>[];

  @Output() issue_saved = new EventEmitter<boolean>();
  @Output() minimised = new EventEmitter<boolean>();
  actions: IssueAction[];
  hub: Hub;
  hasChanges = false;
  private errorMessage: string;

  static handleRefreshError(err: any): void {
    if (err.status !== 401) {
      console.log('IssueActions Error: ' + err);
    }
  }

  constructor(
    private hubService: HubService,
    private route: ActivatedRoute,
  ) {
  }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    if (!this.inHub) { this.inHub = new Hub(); }
    this.hub = Object.assign({}, this.inHub);  // Clone
  }

  updateActions(actions: IssueAction[]): void {
    this.actions = actions;
  }

  refreshActions(): void {
    this.route.params.pipe(
      switchMap((params: Params) => this.hubService.getIssueActions(this.issue.issue_id))
    ).subscribe(
      (actions: IssueAction[]) => this.updateActions(<IssueAction[]>actions), 
      err => ExpandedIssueComponent.handleRefreshError(err)
    );
  }

  onActionSaved(saved: boolean): void {
    // console.log('IssueAction was saved: ' + saved);
    if (saved) {
      this.refreshActions();
      this.issue_saved.emit(true);
    }
  }

  cancel(): void {
    this.minimised.emit(false);
  }

  getSourceText(id: number): string {
    for (let i = 0; i < this.issue_sources.length; i++) {
      if (this.issue_sources[i].issue_source_id === id) {
        return this.issue_sources[i].issue_source_text;
      }
    }
    return 'Unknown';
  }

  getStatusText(id: number): string {
    for (let i = 0; i < this.issue_statuses.length; i++) {
      if (this.issue_statuses[i].issue_status_id === id) {
        return this.issue_statuses[i].issue_status_text;
      }
    }
    return 'Unknown';
  }

  titleChanged() {
    // if (!this.hasChanges) {
    //   console.log('Title has changed');
    // }
    this.hasChanges = true;
  }

  priorityChanged() {
    // if (!this.hasChanges) {
    //   console.log('Priority has changed');
    // }
    this.hasChanges = true;
  }

  tagChanged() {
    // if (!this.hasChanges) {
    //   console.log('Priority has changed');
    // }
    this.hasChanges = true;
  }

  actionChanged(){
    // if (!this.hasChanges) {
    //   console.log('Priority has changed');
    // }
    this.hasChanges = true;
  }

  followupChanged(){
    // if (!this.hasChanges) {
    //   console.log('Priority has changed');
    // }
    this.hasChanges = true;
  }

  descriptionChanged() {
    // if (!this.hasChanges) {
    //   console.log('Description has changed');
    // }
    this.hasChanges = true;
  }

  save(): void {
    if (!!this.hub && !this.issue.hubid) {
      this.issue.hubid = this.hub.hubid;
    }
    if (!this.issue.status || this.issue.status < 1) {
      this.issue.status = 1;
    }
    if (!this.issue.source || this.issue.source < 1) {
      this.issue.source = 1;
    }

    this.issue.source_text = this.getSourceText(this.issue.source);
    this.issue.status_text = this.getStatusText(this.issue.status);
    this.issue.priority = Number(this.issue.priority);
    this.issue.issue_tag_id = Number(this.issue.issue_tag_id);
    this.issue.issue_action_id = Number(this.issue.issue_action_id);
    if (this.issue.customer_followup != true) {
      this.issue.customer_followup = false
    }

   // this.issue.customer_followup = true; 
    this.hubService.writeIssue(this.issue)
      .subscribe(() => {
        this.inHub = this.hub;
        this.refreshActions();
        this.issue_saved.emit(true);
        this.hasChanges = false;
        this.minimised.emit(true);
      });
  }
}
